import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import axios from "axios";
import VueSimpleAlert from "vue-simple-alert";
const CryptoJS = require('crypto-js');

Vue.config.productionTip = false;
Vue.use(VueSimpleAlert);
Vue.prototype.$cryptoJS = CryptoJS;

sync(store, router);

new Vue({
  router,
  store,
  created() {
    const userString = sessionStorage.getItem("setResponse");
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.dispatch("reloadUserData", userData);
    }
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$store.dispatch("logout");
        }
        return Promise.reject(error);
      }
    );
  },
  render: h => h(App)
}).$mount("#app");
